import { useState } from "react";
import "./BetTableCmatch20.css";
import { userSiteAsset } from "../../../utils/userSiteAssets";
import { formatMinMax } from "../betTableBtable/oddsUtils";
import Collapse from "../../../components/Collapse";
import { formatBook } from "../../../utils/formatOdds";

// Cricket Match 20-20 (cmatch20) — admin view only. Original admin markup/classes
// (casino-table cricket20 → score-box, ball-icon, blbox back/lay (filled), c20book,
// min-max ⓘ → icon-range; styles in index.css). Feed: sub "Run 2".."Run 10", remark.
const BALLS_LEFT = [2, 3, 4, 5, 6];
const BALLS_RIGHT = [7, 8, 9, 10];

const isSusp = (item, key) =>
  !item || String(item.gstatus || "").toUpperCase() !== "OPEN" || !(parseFloat(item[key]) > 0);

function ScoreBox({ ball, item, exposures }) {
  const [showRange, setShowRange] = useState(false);
  const n = parseFloat(item?.nat ? exposures?.[item.nat] ?? exposures?.[item.nat.toLowerCase()] : 0);
  const book = Number.isFinite(n) ? n : 0;
  return (
    <div className="score-box" style={{ backgroundImage: `url(${userSiteAsset("img/score-bg.png")})` }}>
      <div className="ball-icon">
        <img src={userSiteAsset(`assets/img/balls/cricket20/ball${ball}.png`)} alt={`Ball ${ball}`} />
      </div>
      <div className="blbox">
        <div className={`back${isSusp(item, "b") ? " suspended" : ""}`}>{item?.b || 0}</div>
        <div className={`lay${isSusp(item, "l") ? " suspended" : ""}`}>{item?.l || 0}</div>
      </div>
      {book !== 0 && (
        <div className="c20book">
          <span className={book > 0 ? "book-green" : "book-red"}>{formatBook(book)}</span>
        </div>
      )}
      <div className="min-max">
        <i className="fas fa-info-circle" onClick={() => setShowRange((v) => !v)} />
        <Collapse open={!!showRange} className="icon-range">
          R:<span>{formatMinMax(item?.min)}</span>-<span>{formatMinMax(item?.max)}</span>
        </Collapse>
      </div>
    </div>
  );
}

export default function BetTableCmatch20({ raw = {}, exposures = {} }) {
  const sub = Array.isArray(raw?.sub) ? raw.sub : [];
  const find = (ball) => sub.find((s) => s?.nat === `Run ${ball}`);
  const col = (balls) =>
    balls.map((ball) => <ScoreBox key={ball} ball={ball} item={find(ball)} exposures={exposures} />);

  return (
    <div className="casino-table cricket20 cmatch20-admin">
      <div className="casino-detail">
        <div className="cmatch20-cols">
          <div className="cmatch20-col">{col(BALLS_LEFT)}</div>
          <div className="cmatch20-col">{col(BALLS_RIGHT)}</div>
        </div>
        {raw?.remark && (
          <div className="casino-remark">
            <marquee scrollamount="3">{raw.remark}</marquee>
          </div>
        )}
      </div>
    </div>
  );
}
